/*
 * @Author: tangke
 * @Date: 2019-01-31 11:06:16
 * @Last Modified by: others
 * @Last Modified time: 2019-03-07 17:09:57
 * training页面
 */
 <template>
  <div>
    <v-container fill-height pa-0
                 fluid>
      <v-layout class="pt-2"
                row
                wrap>
        <v-flex>
          <v-layout row
                    wrap>
            <v-flex xs12>
              <v-card flat class="background-none">
                <v-card-actions class="d-inline-flex pointer_title pa-0"
                                @click="changeOpen(training.isOpen)">
                  <v-icon left color="#3E67FB">
                    book
                  </v-icon>
                  <span class="title font-weight-bold blue-title">Training Consultations</span>
                  <v-icon left color="#3E67FB"
                          large>
                    {{`${training.isOpen? 'arrow_drop_down':'arrow_drop_up'}`}}
                  </v-icon>
                </v-card-actions>
                <v-card-text v-show="training.isOpen"
                             class="elevation-4 training-card blue-title common-card">
                  <ol class="subheading">
                    <li v-for="(item,index) in lists"
                        :key="'top'+index">
                      <div class="font-weight-bold">{{item.title}}</div>
                      <ul :class="`${('pie' === item.type) ? 'list-square': 'list-decimal'} body-1`">
                        <template v-if="'pie' === item.type">
                          <v-layout row
                                    wrap
                                    >
                            <v-flex lg4
                                    md6
                                    v-for="(piece,ind) in item.list"
                                    :key="'min'+ind">
                              <li>{{piece}}</li>
                            </v-flex>
                          </v-layout>
                        </template>
                        <template v-else>
                          <li v-for="(piece,ind) in item.list"
                              :key="'mins'+ind">{{piece}}</li>
                        </template>
                      </ul>
                    </li>
                  </ol>
                  <p>Note: You won't be able to enter the room 10 minutes after the scheduled time, and you would be marked absent.</p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <div class="booked-tip py-2 blue-title">
                Once the course is booked, you can enter the online classroom before the beginning time of the course. <br>
                Enter the class by clicking the botton in the list or logging in your tutor account and password to https://trainingweb.acadsoc.com.cn
                <div>
                  <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                    <v-btn slot="activator"
                    v-on="on"
                      v-show="TLState==1"
                      class="text-none mr-0 mb-3 red-button"
                      style="height:28px;padding:0;width:107px"><button :disabled="true" class="disbtn">Book Class</button></v-btn>
                        
                      </template>
                      <span style="width: 350px">
                      You need to pass the TL to access this feature.
                      </span>
                  </v-tooltip>
                  <bookClass :bookClass="bookClass" @refreshTraining = "refreshTraining"/>
                </div>
              </div>
              <cancel-class :cancelClass="cancelClass" @func="refreshTraining"></cancel-class>
              <train-comment :comment="comment" @func="refreshTraining"></train-comment>
              <view-remark :view="view" v-if="view.dialog" @func="refreshTraining"></view-remark>
              <cancel-qa-demo :cancelQADemo="cancelQADemo" @func="refreshTraining"></cancel-qa-demo>
              <reschedule :reschedule="reschedule" v-if="reschedule.dialog"></reschedule>
              <tl-results :tlResults="tlResults" v-if="tlResults.dialog"></tl-results>
              <v-data-table :headers="allTraining.headers"
                              :items="allTraining.desserts"
                              hide-actions
                              :loading="allTraining.loading"
                              no-data-text="No Data!"
                              class="common-table mt-4">
                  <template slot="items"
                            slot-scope="props">
                    <td>{{ props.item.TrainingTypeStr }}</td>
                    <td>{{ props.item.CourseType }}</td>
                    <td>{{ props.item.ClassTimeStr }}</td>
                    <td>{{props.item.StatusStr}}</td>
                    <td v-html="props.item.Trainer">{{ props.item.Trainer }}</td>
                    <td>{{ props.item.BookTime }}</td>
                    <!-- MT -->
                    <td v-if="props.item.TrainingType==2">
                      <v-btn v-show="currentTime<props.item.ClassTimeStart && props.item.Status!==2" small
                             class="text-none red-border-button"
                             @click="cancel(props.item.Id)">Cancel</v-btn>
                      <v-btn small
                             v-show="currentTime>props.item.ClassTimeEnd && props.item.Status!==2 && props.item.Status!==5 && props.item.Status!==1 && currentTime<props.item.ClassTimeEnd+48*60*60*1000"
                             class="text-none white--text border-button-public yellow-border-button"
                             @click="absent(props.item.Id)">Trainer Absent</v-btn>
                      <v-btn small
                             v-show="(props.item.TraineeEvaluation=='' || props.item.TraineeEvaluation==null)&&!props.item.IsNewEvaluation && currentTime>props.item.ClassTimeEnd && props.item.Status==1"
                             class="text-none border-button-public purple-border-button"
                             @click="evaluate(props.item.Id,props.item.CourseType,props.item.Trainer,props.item.ClassTimeStr)">Leave Remarks</v-btn>
                      <v-btn small
                             v-show="props.item.Status == 1"
                             class="text-none white--text border-button-public green-border-button"
                             @click="viewRemark(props.item)">View Remarks</v-btn>
                              <!-- v-show="(props.item.TraineeEvaluation!==''&&props.item.TraineeEvaluation!==null) || props.item.IsNewEvaluation" -->
                      <v-btn small
                              v-show="currentTime>props.item.ClassTimeStart-1800000 && currentTime<props.item.ClassTimeEnd && props.item.Status!==2"
                              class="text-none white--text blue-border-button"
                              :loading="MTLoading"
                              @click="JoinAClassRoomTraining(1,props.item.RoomNumber,props.item.TrainingSubTypeName)">Enter the class</v-btn>
                    </td>
                    <!-- PT -->
                    <td v-else-if="props.item.TrainingType==1">
                      <v-btn small
                              v-show="currentTime>props.item.ClassTimeStart-1800000 && currentTime<props.item.ClassTimeEnd"
                              class="text-none white--text blue-border-button"
                              :loading="PTLoading"
                              @click="JoinAClassRoomTraining(2,props.item.RoomNumber,props.item.TrainingSubTypeName)">Enter the class</v-btn>
                      <v-btn small
                             v-show="currentTime<props.item.ClassTimeStart && props.item.Status==25"
                             class="text-none white--text border-button-public pink-border-button"
                             @click="rescheduleTime()">Reschedule</v-btn>
                    </td>
                    <td v-else-if="props.item.TrainingType==3">
                      <v-btn small
                              :disabled="props.item.Status === 2 || props.item.Status === 3"
                              class="text-none white--text border-button-public"
                              :class="props.item.Status === 3 ? 'red-border-button' : 'blue-border-button'"
                              @click="toBeTrained(props.item.Id)">{{ props.item.Status === 2 ? 'Finished' : props.item.Status === 3 ? 'Cancelled' : 'Enter the Class'}}</v-btn>
                    </td>
                    <!-- 新老师试课 PT-QA -->
                    <td v-else-if="props.item.TrainingType==4">
                      <!-- <v-btn v-show="currentTime<props.item.ClassTimeStart-1800000 && props.item.Status==46" 
                              small
                             class="text-none red-border-button"
                             @click="cancelQA(props.item.Id,4)">Cancel</v-btn> -->
                      <v-btn small
                              v-show="currentTime>props.item.ClassTimeStart-3600000 && currentTime<props.item.ClassTimeEnd && props.item.Status==46"
                              class="text-none white--text blue-border-button"
                              :loading="QALoading"
                              @click="JoinAClassRoomTraining(3,props.item.RoomNumber,props.item.TrainingSubTypeName)">Enter the class</v-btn>
                    </td>
                    <!-- 老老师试课 MT-QA -->
                    <td v-else-if="props.item.TrainingType==5">
                      <v-btn v-show="currentTime<props.item.ClassTimeStart-1800000 && props.item.Status==19"
                              small
                             class="text-none red-border-button"
                             @click="cancelQA(props.item.Id,5)">Cancel</v-btn>
                      <v-btn small
                              v-show="currentTime>props.item.ClassTimeStart-3600000 && currentTime<props.item.ClassTimeEnd && props.item.Status==19"
                              class="text-none white--text blue-border-button"
                              :loading="QALoading"
                              @click="JoinAClassRoomTraining(3,props.item.RoomNumber,props.item.TrainingSubTypeName)">Enter the class</v-btn>
                      <v-btn small
                              v-show="props.item.IsQAScore"
                              class="text-none white--text blue-border-button"
                              @click="getTLResultDetailFun(props.item.Id,5)">TL Results</v-btn>
                    </td>
                    <td v-else-if="props.item.TrainingType==6">
                      <v-btn small
                              v-show="props.item.IsQAScore"
                              class="text-none white--text blue-border-button"
                              @click="getTLResultDetailFun(props.item.Id,6)">TL Results</v-btn>
                    </td>
                  </template>
                </v-data-table>
                <div class="text-xs-left pt-4">
                  <v-pagination class="common-pagination"
                                v-model="allTrainingPagination.pageIndex"
                                @input="allTrainingSearch"
                                :total-visible="allTrainingPagination.totalVisible"
                                :length="allTrainingPagination.totalPages"></v-pagination>
                </div>
                <template slot="no-data">
                  <v-btn color="primary">Reset</v-btn>
                </template>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog lazy
              max-width="30em"
              v-model="showAClassRoom">
      <v-card>
        <v-card-text>
          <template v-if="fetchingIframeUrl">
            <h3 class="text-xs-center">Loading...</h3>
          </template>
          <template v-else>
            <h2>Have you installed A-Classroom?</h2>
            <p>The client application can be started from this page only if A-Classroom is installed.</p>
            <p>If it is not installed, please download and install it first.</p>
            <v-card-actions>
              <v-layout justify-center>
                <v-btn color="primary"
                    class="white--text text-none"
                    @click="showAClassRoom = false">OK</v-btn>
              </v-layout>
          </v-card-actions>
          </template>
          <iframe :src="iframeUrl"
                  frameborder="0"
                  v-if="showAClassRoom && !fetchingIframeUrl"
                  v-show="false"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { trainerAbsent, getAClassRoomWebLink,userExtInfo } from '@/api/teachinfo'
import { getTrailCourseClassroomUrl, getChangeGroupTips, getAllTrainingList, getTLResultDetail} from '@/api/trainning.js'
import bookClass from './bookClass'
import trainComment from './comment'
import viewRemark from './viewRemark'
import cancelClass from './cancelClass'
import reschedule from './calendarProcess'
import cancelQaDemo from './cancelQADemo'
import tlResults from './tlResults'
import { formatDate } from '@/utils/date.js'
import dateFileter from '@/filters/dateFilter'
import { mapGetters } from 'vuex'
import { setCookie, getCookie, clearCookie, urlParamsToObject } from '@/utils/tools'

export default {
  name: 'onlineTraining',
  data: () => ({
    lists: [
      {
        title: 'Currently, we have 14 Training Courses listed as follow：',
        list: [
          'English for Kids (EFK)',
          'English for Kids（age 3-6） Level 1 (EFK1 )',
          'English for Kids (age 7-12) Level 2 (EFK2)',
          'English for Kids (age 13-18) Level 3 (EFK3)',
          'Accent Training（AT）',
          'Top Tutor Training (T3 / TTT)',
          'Exam Preparation: IELTS/TOEFL (EP)',
          'Refresher Course (RC)',
          'Top Tutor Refreshing Course (TTRC)',
          'Grammar Material Training (GMT)',
          'English for Adults(EFA)',
          'Trial Class for Adults（TCA）',
          'Workshop for VIP tutors(WVIP)',
          'Workshop for Trial Class tutors(WTT)',
        ],
        type: 'pie'
      },
      {
        title: 'How to book a training for yourself ?',
        list: [
          'If the training has a preview lesson, please finish it at Training Center- Self-study courses-MT training.',
          "Book the training via 'Training Center-Training Consultations' 2 hours in advance.",
          'Your training should show in A-Classroom once you book your training. You can enter the classroom 5 minutes before the scheduled time.',
          "Please contact your trainer prior to training schedule for any questions, concerns or issues. ( Trainer's info is available in MT training).",
          "Same classroom rules applies as if it's a regular class. Contact or respond to your trainer before the training time. Make sure to enter the classroom on or 5 mins before the time."
        ],
        type: 'lists'
      }
    ],
    bookClass: {
      dialog: false
    },
    cancelClass:{
      dialog:false,
      id:0
    },
    comment: {
      dialog: false,
      id: 0,
      courseType: '',
      trainer:''
    },
    view:{
      dialog: false,
      trainId:0,
      IsNewEvaluation:false,
      TrainerId:0,
      TraineeId:0,
      TrainerName:"",
      TraineeName:"",
      TrainerEvaluation:"",
      TraineeEvaluation:""
    },
    training: {
      isOpen: false,
    },
    showAClassRoom:false,
    fetchingIframeUrl:false,
    iframeUrl:'',
    reschedule:{
      dialog:false,
      currentTime:''
    },
    allTraining:{
      headers: [
        {
          text: 'Training Type',
          sortable: false,
          value: 'TrainingTypeStr'
        },
        {
          text: 'Course Type',
          sortable: false,
          value: 'CourseType'
        },
        {
          text: 'Class Time',
          sortable: false,
          value: 'ClassTimeStr'
        },
        {
          text: 'Status',
          sortable: false,
          value: 'StatusStr'
        },
        {
          text: 'Trainer',
          sortable: false,
          value: 'Trainer'
        },{
          text: 'Book Time',
          sortable: false,
          value: 'BookTime'
        },
        {
          text: 'Actions',
          value: 'name',
          sortable: false
        }
      ],
      desserts: [],
      loading:false
    },
    allTrainingPagination:{
      pageIndex: 1,
      pageSize: 15,
      totalVisible: 7,
      totalPages: 0
    },
    currentTime:null,
    cancelQADemo:{
      dialog:false,
      id:0,
      type:0
    },
    QALoading:false,
    MTLoading:false,
    PTLoading:false,
    tlResults:{
      dialog:false,
      id:0
    },
    TLState: "",
  }),
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  filters: { 
    dateFileter
  },
  mounted () {
    this.allTrainingSearch()
  },
  components: {
    bookClass,
    trainComment,
    viewRemark,
    cancelClass,
    // eslint-disable-next-line vue/no-unused-components
    reschedule,
    cancelQaDemo,
    tlResults
  },
  methods: {
    changeOpen (e) {
      this.training.isOpen = !e
    },
    allTrainingSearch(){
      this.allTraining.loading = true
      this.currentTime = new Date().getTime();
      getAllTrainingList(this.allTrainingPagination.pageIndex-1,this.allTrainingPagination.pageSize).then(res=>{
        if(res.data.ErrorCode==0 && res.data.Body){
          var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
          this.allTraining.desserts = res.data.Body.Items
          this.allTrainingPagination.totalPages = res.data.Body.TotalPages
          this.allTraining.desserts.forEach((v)=>{
            if(v.TrainingType==1){
              this.reschedule.currentTime = formatDate(v.ClassTimeStart,'MM-dd-yyyy hh:mm')+" - "+formatDate(v.ClassTimeEnd,'hh:mm')
            }
            if(isMac){
              v.ClassTimeStart = new Date(v.ClassTimeStart.replace("T"," ").replace(/-/g, "/")).getTime();
              v.ClassTimeEnd = new Date(v.ClassTimeEnd.replace("T"," ").replace(/-/g, "/")).getTime();
            }else{
              v.ClassTimeStart = new Date(v.ClassTimeStart).getTime();
              v.ClassTimeEnd = new Date(v.ClassTimeEnd).getTime();
            }
          })
        }
      }).finally(()=>{
        this.allTraining.loading = false
      })
    },
    cancelQA(id,type){
      this.cancelQADemo.dialog = true;
      this.cancelQADemo.id = id;
      this.cancelQADemo.type = type
    },
    evaluate (id,courseType,trainer,time) {
      this.comment.dialog = true
      this.comment.id = id
      this.comment.courseType = courseType
      this.comment.trainer = trainer
      this.comment.time = time
    },
    cancel (id) {
      this.cancelClass.dialog = true;
      this.cancelClass.id = id;
    },
    absent(id){
      this.$root.$confirm('Are you sure to mark the course as trainer absent? (Please operate carefully. Submitting false information will affect your assessment.)','default',{width:430}).then((isOk) => {
        if (!isOk) return
        trainerAbsent(id).then(res=>{
          if(res.data.ErrorCode !==0 && res.data.Msg==='JoinClass'){
            this.$root.$alertTips('Detected trainer have  entered the classroom.Any questions, please click "Leave Remarks" button in the training list to give your feedback after the course.','',{icon:{default:true}})
          }else{
            let type = res.data.ErrorCode === 0 ? 'success' : 'error'
            this.$root.$alertTips(res.data.Msg, type).then(() => {
                this.refreshTraining()
            })
          }
        })
      })
    },
    refreshTraining () {
      this.allTrainingSearch()
    },
    viewRemark(item){
        if (item) {
          this.view.dialog = true;
          this.view.trainId = item.Id
          this.view.IsNewEvaluation = item.IsNewEvaluation
          this.view.TrainerId = item.TrainerUserId;
          this.view.TraineeId = this.user.tuid;
          this.view.TrainerName = item.Trainer;
          this.view.TraineeName = item.Trainee;
          this.view.TrainerEvaluation = item.TrainerEvaluation;
          this.view.TraineeEvaluation = item.TraineeEvaluation;
        }
    },
    JoinAClassRoomTraining(type,roomNumber,trainingSubTypeName){
      // 链接跳转
      this.$root.$confirm(
                `Click [confirm] to log in to online training classroom automatically.`,
                'default',
                { 
                    awaitSubmit: true,
                    width:470,
                    confirmBtn:{
                        display:true,
                        color:"primary"
                    },  
                    cancelBtn:{
                        display:true,
                        color:"white"
                    }
                })
        .then(({ result, submitcomplete }) => {
            if (result) {
                submitcomplete();
                if(type==1) this.MTLoading = true;
                else if(type==2) this.PTLoading = true;
                else this.QALoading = true
                var client = getCookie("client")
                var isclient=0
                if (client=="tutorclient"){
                    isclient=1
                }                
                getAClassRoomWebLink(type,isclient,roomNumber,trainingSubTypeName).then(res=>{
                  if(res.data.Body && res.data.Body.AClassRoomWebLink){
                    if (client=="tutorclient"){
                        window.location.href=res.data.Body.AClassRoomWebLink
                    }else{
                        window.open(res.data.Body.AClassRoomWebLink)
                    }
                  }
                }).finally(()=>{
                  this.QALoading = false;
                  this.MTLoading = false;
                  this.PTLoading = false
                })
            }
        })
      
    },
    rescheduleTime(){
      this.reschedule.dialog = true;
    },
    toBeTrained(id) { //进入培训室
     let TT = `<div style="text-align:left; padding: 0 26px;">Cheers! You are now one of our Top Tutors.<br/>
              We have assessed your trial classes for the past 3 months and we officially nominate you as a Top Tutor. It means you will have more trial classes from now on. Please do give attention to your trial classes. <br/>
              1.  For trial slots: You will get more slots (at least 4 hours a day) for trial slots. <br/>
              2.  For your package: Your package will be converted to Old Package, “unbooked trial classes should be paid on a base rate basis”, while you are a TOP TUTOR. <br/>
              3. By the time being, you have been a TOP TUTOR. Please focus more on the performance of the trial class. Be creative and create a happy and fun class for your students. Good luck to you!<br/>
              For more details, please consult your DS. Thank you!</div>`
    let NT = `<div style="text-align:left; padding: 0 26px;">You are now one of our New Top Tutors.<br/>
              We have assessed your trial classes for the past 3 months and we need to inform you of some changes. It's not evaluation but we consider it as focusing more on a different type of class. <br/>
            1. For trial slots: You will gain 2 hours' trial slots a day from now on. <br/>
            2. For your package: Your package will be set to New Package.<br/>
            3. During the time being, since you will be handling trial class students and VIP students simultaneously, please focus more on practicing and improving your teaching skills and give the best performance to the students. And wait another month to check on your trial class potentials. Good luck to you! <br/>
            For more details, please consult your DS. Thank you!</div>`
    let DT = `<div style="text-align:left; padding: 0 26px;">For trial class observation and re-assessment as a Top tutor.<br/>
            We have assessed your trial classes for the past 3 months and this is to notify you of a few changes. It considers doing more in a different type of class. <br/>
            1. For trial slots: You won't be able to avail as of the moment. Don't worry, your trial slot can resume by the New Top Assessment by the QA team. <br/>
            2. For your package: Your package will be set to New Package.<br/>
            3. By the time being, we encourage you to focus more on your VIP classes and wait for another month to check on your trial class potentials. <br/>
            For more details, please consult your DS. Thank you!</div>`
      
      getChangeGroupTips(id).then(res=>{
        if(res.data.Body.groupType){
          let tips = res.data.Body.groupType == 'TT' ? TT : res.data.Body.groupType == 'NT' ? NT : res.data.Body.groupType == 'DT' ? DT : ''
          this.$root.$confirm(
                tips,
                'default',
                { 
                    awaitSubmit: true,
                    width:870,
                    confirmBtn:{
                        display:true,
                        color:"primary"
                    }
                })
                .then(({ result, submitcomplete }) => {
                    if (result) {
                        submitcomplete();
                        this.getClassUrl()
                    }
                })
        }else{
          this.getClassUrl()
        }
      })
    },
    getClassUrl(){
      var client = getCookie("client")
      var isclient=0
      if (client=="tutorclient"){
          isclient=1
      }
      getTrailCourseClassroomUrl(isclient).then(res=>{
        if(res.data.ErrorCode === 0){
          if (client=="tutorclient"){
              window.location.href=res.data.Body.url+"&isclient=1"
          }else{
              window.open(res.data.Body.url);
          }
        }
        })
    },
    getTLResultDetailFun(id,trainingType){
      this.tlResults.dialog = true;
      this.tlResults.id = id;
      this.tlResults.trainingType = trainingType;
    }
  },
  created() {
    userExtInfo().then(res=>{
      this.TLState = res.data.Body.TLState;
    })
  }
}
</script>
<style scoped>
  .checkBoxPoP .v-label {
    font-size: 14px;
  }
  .training-card{
    line-height: 30px;
    margin: 10px 0;
    border-radius: 5px;
  }
.disbtn {
  background-color: #DCDCDC;
  color: white;
  position: absolute;
  width: 100%;
  height: 28px;
  top: -14px;
  left: 0;
  border-radius: 3px;
}
</style>

<style lang="sass" scoped>
@import './training'
</style>
